<!-- TableInsert.vue -->
<template>
  <div class="table-insert-wrapper">
    <!-- Table Button -->
    <button ref="tableButton"
            class="toolbar-btn relative"
            title="Insert Table"
            @click="toggleTablePopup">
      <i class="fas fa-table"></i>
    </button>

    <!-- Table Grid Popup -->
    <div v-show="isPopupVisible"
         ref="tableGridPopup"
         class="table-grid-popup">
      <div ref="tableGrid" class="table-grid">
        <div v-for="i in 64"
             :key="i"
             class="table-cell"
             @mouseover="handleCellHover(i - 1)"
             @click="handleCellClick"
             :class="{ active: isCellActive(i - 1) }"></div>
      </div>
      <div class="table-dimensions">{{ dimensionsText }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TableInsert',

    props: {
      // The target editable element where the table will be inserted
      editor: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        isPopupVisible: false,
        selectedRows: 0,
        selectedCols: 0,
        gridSize: {
          rows: 8,
          cols: 8
        }
      }
    },

    computed: {
      dimensionsText() {
        return `${this.selectedRows} × ${this.selectedCols}`
      }
    },

    methods: {
      toggleTablePopup(e) {
        e.stopPropagation()
        this.isPopupVisible = !this.isPopupVisible

        if (this.isPopupVisible) {
          this.$nextTick(() => {
            const rect = this.$refs.tableButton.getBoundingClientRect();
            const left = this.$refs.tableButton.offsetLeft;
            const top = this.$refs.tableButton.offsetTop + this.$refs.tableButton.offsetHeight;

            this.$refs.tableGridPopup.style.top = `${top + 5}px`
            this.$refs.tableGridPopup.style.left = `${left}px`
            this.$refs.tableGridPopup.style.display = 'block';
          })
        }
      },

      handleCellHover(index) {
        const row = Math.floor(index / this.gridSize.cols) + 1
        const col = (index % this.gridSize.cols) + 1
        this.selectedRows = row
        this.selectedCols = col
      },

      isCellActive(index) {
        const currentRow = Math.floor(index / this.gridSize.cols) + 1
        const currentCol = (index % this.gridSize.cols) + 1
        return currentRow <= this.selectedRows && currentCol <= this.selectedCols
      },

      handleCellClick() {
        if (this.selectedRows > 0 && this.selectedCols > 0) {
          this.insertTable(this.selectedRows, this.selectedCols)
          this.isPopupVisible = false
        }
      },

      insertTable(rows, cols) {
        const table = document.createElement('table')

        // Create header row
        const headerRow = document.createElement('tr')
        for (let i = 0; i < cols; i++) {
          const th = document.createElement('th')
          th.innerHTML = `Col ${i}`;

          headerRow.appendChild(th)
        }
        table.appendChild(headerRow)

        // Create data rows
        for (let i = 1; i < rows; i++) {
          const tr = document.createElement('tr')
          for (let j = 0; j < cols; j++) {
            const td = document.createElement('td')
            td.innerHTML = `Col ${i} ${j}`;
            tr.appendChild(td)
          }
          table.appendChild(tr)
        }

        var outerHTML = table.outerHTML; //table.outerHTML;

        var instance = this;
        this.$nextTick(() => {
          instance.editor.chain().focus().insertContent(outerHTML).focus("end").run();
        });
      },

      handleDocumentClick(e) {
        if (
          this.isPopupVisible &&
          !this.$refs.tableGridPopup.contains(e.target) &&
          e.target !== this.$refs.tableButton
        ) {
          this.isPopupVisible = false
        }
      }
    },

    mounted() {
      document.addEventListener('click', this.handleDocumentClick)
    },

    beforeDestroy() {
      document.removeEventListener('click', this.handleDocumentClick)
    }
  }
</script>

<style scoped>
  .table-insert-wrapper {
    position: relative;
    display: inline-block;
  }

  .toolbar-btn {
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
    color: #666;
    transition: all 0.2s;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

    .toolbar-btn:hover {
      background-color: #f3f4f6;
      color: #000;
    }

    .toolbar-btn.active {
      background-color: #e5e7eb;
      color: #000;
    }

  .table-grid-popup {
    position: absolute;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    z-index: 1000;
  }

  .table-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 2px;
    width: 200px;
  }

  .table-cell {
    width: 20px;
    height: 20px;
    border: 1px solid #e5e7eb;
    background: white;
    transition: all 0.15s;
    cursor: pointer;
  }

    .table-cell.active {
      background: #e5e7eb;
    }

  .table-dimensions {
    text-align: center;
    margin-top: 5px;
    font-size: 12px;
    color: #666;
  }

  /* Styles for inserted tables */
  :deep(.editor-table) {
    border-collapse: collapse;
    width: 100%;
    margin: 1rem 0;
  }

  :deep(.editor-table th),
  :deep(.editor-table td) {
    border: 1px solid #e5e7eb;
    padding: 8px;
    text-align: left;
  }

  :deep(.editor-table thead) {
    background-color: #f3f4f6;
  }
</style>
